import { Label } from '@chain-zen/ui'

import type { IStopWarehouse } from '../../../../../../types/shipment'
import { UpdateStopWarehouse } from '../update-stop-warehouse'
import { WarehouseDisplay } from './warehouse-display'

interface WarehouseInputProps {
  isEditing: boolean
  onCancelEdit: () => void
  onEdit: () => void
  onWarehouseUpdate: (warehouse: IStopWarehouse | null) => void
  warehouse: IStopWarehouse | null
}

/**
 * Input component for editing warehouse inline
 */
export const WarehouseInput = ({
  warehouse,
  isEditing,
  onEdit,
  onCancelEdit,
  onWarehouseUpdate
}: WarehouseInputProps) => {
  const handleUpdateComplete = (updatedWarehouse: IStopWarehouse | null) => {
    onWarehouseUpdate(updatedWarehouse)
  }

  return (
    <div className="space-y-1">
      <Label className="text-xs font-medium">Warehouse</Label>
      {isEditing ? (
        <UpdateStopWarehouse
          locationID={warehouse?.locationID || ''}
          onAddressUpdate={handleUpdateComplete}
          onCancel={onCancelEdit}
          currentWarehouse={warehouse}
        />
      ) : (
        <WarehouseDisplay warehouse={warehouse || null} onEdit={onEdit} />
      )}
    </div>
  )
}
